import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './AdBanner.css';

/**
 * Advertisement banner component
 * @param {Object} props - Component props
 * @param {string} props.position - Banner position (header, footer, sidebar)
 */
function AdBanner({ position = 'footer' }) {
  return (
    <div className={`ad-banner ad-banner-${position}`}>
      <div className="ad-content">
        <div className="ad-icon">
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            viewBox="0 0 24 24"
            width="24"
            height="24"
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
          >
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
          </svg>
        </div>
        
        <p className="ad-text">
          Upgrade to Premium for an ad-free experience, unlimited projects, and advanced features!
        </p>
        
        <Link to="/premium" className="ad-link">
          Upgrade Now
        </Link>
        
        <button className="ad-close" aria-label="Close advertisement">
          &times;
        </button>
      </div>
    </div>
  );
}

AdBanner.propTypes = {
  position: PropTypes.oneOf(['header', 'footer', 'sidebar'])
};

export default AdBanner;
